module.exports = __webpack_public_path__ + "img/Cloud.196963e5.png";